import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import { applyClasses, applyProps } from '../shared/js';

import styles from './form.module.scss';

const FormRow = ({ children, ...props }) => {
  const classes = applyClasses(props, styles);
  const arrayChildren = React.Children.toArray(children);
  const rightColumnsWidth = `${100 / arrayChildren.slice(1).length}%`;
  return (
    <div
      id={props.id}
      // eslint-disable-next-line react/prop-types
      className={cn(styles.formRow, props.className, classes)}
      {...applyProps(props)}
    >
      <div
        className={cn(styles.column, {
          [styles.narrowColumn]:
            arrayChildren[0].props?.narrow ||
            arrayChildren[0].props?.narrowDesktop,
          [styles.short]: props.short,
        })}
      >
        {arrayChildren[0]}
      </div>
      <div className={cn(styles.right)}>
        {arrayChildren.slice(1).map(
          (child, index) =>
            child && (
              <div
                key={index}
                className={cn(styles.column, {
                  [styles.narrowColumn]:
                    arrayChildren[0].props?.narrow ||
                    arrayChildren[0].props?.narrowDesktop,
                  [styles.short]: props.short,
                })}
                style={{ width: rightColumnsWidth }}
              >
                {child}
              </div>
            )
        )}
      </div>
    </div>
  );
};

FormRow.propTypes = {
  /** The ID of the row element. Useful to select the row during testing. */
  id: PropTypes.string,
  /** Make the first column span two thirds of the row */
  wide: PropTypes.bool,
  /** Make the first column span one third of the row  */
  narrow: PropTypes.bool,
  /** Make the first column span half of the row */
  half: PropTypes.bool,
  /** Make the first column span the full width of the row */
  full: PropTypes.bool,
  /** Add a border and padding around the row */
  box: PropTypes.bool,
  /** Align each column to the top of the row */
  alignTop: PropTypes.bool,
  /** Align each column to the bottom of the row */
  alignBottom: PropTypes.bool,
  /** Reduce the margins below the columns in the row */
  short: PropTypes.bool,
  /** The columns in the form row */
  children: PropTypes.any,
};

FormRow.defaultProps = {
  children: undefined,
  wide: undefined,
  narrow: undefined,
  half: undefined,
  full: undefined,
  box: undefined,
  alignTop: undefined,
  alignBottom: undefined,
  short: undefined,
};

export default FormRow;
